import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ children, hide }) => {
  const location = useLocation();
  const pageClass = location.pathname.replace("/", "") || "home";

  return (
    <div className={`${pageClass}-wrapper`} style={{ opacity: hide ? 0 : 1 }}>
      <header>
        <Header />
      </header>
      <main className={`page-${pageClass}`}>{children}</main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};

export default Layout;
